import React from 'react';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../../components/ui/dialog';
import { CheckCircle, Lock, ShoppingCart, Sparkles } from 'lucide-react';
import { CATEGORY_META, PACKAGE_LABEL } from './constants';

export const InhaberCourseDialog = ({
  open,
  onOpenChange,
  selectedEmployee,
  allCourses = [],
  freeTrialModuleId,
  activatedPackageModules = [],
  hasPaidSubscription,
  onActivate,
  onOpenCheckout }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="bg-gray-900 border-gray-800 max-w-2xl">
      <DialogHeader>
        <DialogTitle className="text-white">Kurse für {selectedEmployee?.name}</DialogTitle>
        <DialogDescription>
          Im Testbetrieb können Sie kostenfrei den Pflichtkurs zuweisen. Weitere Schulungen werden über Digistore24-Pakete freigeschaltet.
        </DialogDescription>
      </DialogHeader>
      <div className="space-y-2.5 max-h-[60vh] overflow-y-auto pr-1">
        {allCourses.map((mod) => {
          const isActivated = selectedEmployee?.activatedCourses?.includes(mod.id);
          const isFree = mod.id === freeTrialModuleId;
          const isUnlocked = isFree || activatedPackageModules.includes(mod.id);
          const cat = CATEGORY_META[mod.category] || CATEGORY_META.basis;

          return (
            <div
              key={mod.id}
              className="flex items-center justify-between p-3 bg-black/30 rounded-lg border border-gray-800 gap-3"
              data-testid={`assign-row-${mod.id}`}
            >
              <div className="flex items-start gap-3 min-w-0 flex-1">
                <div className="text-2xl shrink-0">{mod.icon || '📘'}</div>
                <div className="min-w-0">
                  <p className="text-white font-medium truncate">{mod.title}</p>
                  <div className="flex flex-wrap items-center gap-1.5 mt-1">
                    <Badge className={`${cat.color} border text-[10px]`}>{cat.label}</Badge>
                    {isFree && (
                      <Badge className="bg-green-500/20 text-green-400 border-green-500/30 border text-[10px]">
                        Gratis Testkurs
                      </Badge>
                    )}
                    {!isFree && !isUnlocked && (
                      <Badge className="bg-red-500/15 text-red-400 border-red-500/30 border text-[10px]">
                        <Lock className="w-2.5 h-2.5 mr-1" />Premium
                      </Badge>
                    )}
                    <span className="text-[10px] text-gray-500">
                      {mod.duration_minutes || 45} Min · {mod.total_lessons || 6} Lektionen
                    </span>
                  </div>
                </div>
              </div>
              {isActivated ? (
                <Badge className="bg-green-500/20 text-green-500 border-green-500/50 shrink-0">
                  <CheckCircle className="h-4 w-4 mr-1" /> Aktiv
                </Badge>
              ) : isUnlocked ? (
                <Button
                  size="sm"
                  className="bg-yellow-500 text-black hover:bg-yellow-400 font-medium shrink-0"
                  onClick={() => onActivate(selectedEmployee.id, mod.id)}
                  data-testid={`activate-btn-${mod.id}`}
                >
                  Zuweisen
                </Button>
              ) : (
                <Button
                  size="sm"
                  variant="outline"
                  className="border-yellow-500/50 text-yellow-400 hover:bg-yellow-500/10 shrink-0"
                  onClick={() => mod.package_type && onOpenCheckout(mod.package_type)}
                  data-testid={`unlock-btn-${mod.id}`}
                >
                  <ShoppingCart className="w-3.5 h-3.5 mr-1.5" />
                  {PACKAGE_LABEL[mod.package_type] || 'Paket buchen'}
                </Button>
              )}
            </div>
          );
        })}
      </div>
      {!hasPaidSubscription && (
        <div className="mt-4 bg-yellow-500/10 border border-yellow-500/30 rounded-lg p-3 flex items-start gap-2">
          <Sparkles className="w-4 h-4 text-yellow-500 shrink-0 mt-0.5" />
          <p className="text-xs text-yellow-200/90">
            <strong>Hinweis:</strong> Ohne Premium-Abo können Sie nur den Pflicht-Testkurs (DGUV Vorschrift 1) zuweisen. Buchen Sie ein Paket, um weitere Kurse für Ihr Team freizuschalten.
          </p>
        </div>
      )}
    </DialogContent>
  </Dialog>
);
